// @flow
export { default } from './Icon';
